export default "/images/vendor/@coreui/icons/svg/flag/cif-lc.svg?9ee7e602f947f736931c5c14ac461d77";